import React, { Component } from 'react';
import PaginationBuilder from './../../common/PaginationBuilder';
import {loadCsrf} from './../../common/CsrfFetcher';
import AddNetPromoterScorePointsTrackingComponent from './AddNetPromoterScorePointsTrackingComponent';
import {addNetPromoterScorePointsTrackingData, getNetPromoterScorePointsTrackingData, deleteNetPromoterScorePointsTrackingData} from './FetchCallsNetPromoterScorePointsTrackingData';

class NetPromoterScorePointsTracking extends Component {

    constructor(props) {
        super(props);
        var currentUrl = window.location.href;
        var searchString = '?orgId=';
        var index = currentUrl.indexOf(searchString);
        var parsedOrgId = '';
        if(index !== -1){
            parsedOrgId = currentUrl.substring(index + searchString.length, currentUrl.length)
        }
		this.state = {
            csrfToken:'',
            csrfTokenHeaderName:'',
            pageRangeDisplayed:5,
            orgId:parsedOrgId,
            netPromoterScorePointsTrackingResult : undefined,
            itemsPerPage:10,
            isPaginationRequired:false,
            pageItems:[],
            deleteRequestAllowed:true,
            addRequestAllowed:true
		};
		this.paginator = React.createRef();
	}

    componentDidMount() {
        loadCsrf(this.setCsrfState);
        return this.getNetPromoterScoreTrackingData(this.state.orgId);
    }

    getNetPromoterScoreTrackingData = (orgId) => {
        getNetPromoterScorePointsTrackingData(orgId).then(resultList =>
            this.setState({
                netPromoterScorePointsTrackingResult: resultList,
                pageItems: resultList.slice(resultList, this.state.itemsPerPage),
                isPaginationRequired : resultList.length > this.state.itemsPerPage
            })
        );
    }

    setCsrfState = (csrfTokenFetch, csrfHeaderValueFetch)=>{
        this.setState({
            csrfToken : csrfTokenFetch,
            csrfTokenHeaderName : csrfHeaderValueFetch
        })
    }

    deleteNetPromoterScoreTrackingData = (app) => {
        if(this.state.deleteRequestAllowed !== true){ return } else {
            this.setState({ deleteRequestAllowed : false });
        }
        return this.fetchDeleteNetPromoterScoreTrackingData(app, this.state.csrfToken);
    }

    fetchDeleteNetPromoterScoreTrackingData = (app, csrfToken) => {
        const {netPromoterScorePointsTrackingResult} = this.state;
        return deleteNetPromoterScorePointsTrackingData(app.id, csrfToken).then(response =>
            {
                let resultList = netPromoterScorePointsTrackingResult.filter(item => item !== app)
                this.setState({
                    deleteRequestAllowed : true,
                    netPromoterScorePointsTrackingResult: resultList,
                    pageItems: resultList.slice(resultList, this.state.itemsPerPage),
                    isPaginationRequired : resultList.length > this.state.itemsPerPage
                })
            }
        );
    }

    addNetPromoterScoreTrackingData = (payLoad) => {
        if(this.state.addRequestAllowed !== true){ return } else {
            this.setState({ addRequestAllowed : false });
        }
        return this.fetchAddNetPromoterScorePointsTrackingData(JSON.stringify(payLoad), this.state.csrfToken);
    }

    fetchAddNetPromoterScorePointsTrackingData = (payLoad, csrfToken) => {
        return addNetPromoterScorePointsTrackingData(payLoad, csrfToken).then(response =>
            {
                this.setState({ addRequestAllowed : true })
                this.getNetPromoterScoreTrackingData(this.state.orgId)
            }
        );
    }

    render() {
        const {netPromoterScorePointsTrackingResult, pageItems, isPaginationRequired, itemsPerPage} = this.state;
        if(netPromoterScorePointsTrackingResult === undefined){
            return null
		} else if(isPaginationRequired === true){
			return (
				<React.Fragment>
                <AddNetPromoterScorePointsTrackingComponent
                    addNetPromoterScoreTrackingData={this.addNetPromoterScoreTrackingData}
                    orgId={this.state.orgId}
                />
				<NetPromoterScorePointsTrackingTable 
                    id='NPSPointsTrackingTable'
                    key="netPromoterScorePointsTrackingTable" 
                    applications={pageItems}
                    deleteNetPromoterScoreTrackingData = {this.deleteNetPromoterScoreTrackingData}
				/>
                <PaginationBuilder
                    id='pagination'
					key="paginationBuilder" 
					ref={this.paginator} 
					items={netPromoterScorePointsTrackingResult}
					totalItems={netPromoterScorePointsTrackingResult.length}
				    serverSidePagination="false"
					refreshPage={this.refreshPage}
					itemsPerPage={itemsPerPage}  
					pageRangeDisplayed={this.state.pageRangeDisplayed}
				/>
                </React.Fragment>
                )
		} else if(isPaginationRequired === false && netPromoterScorePointsTrackingResult.length > 0) {
            return (
            		<React.Fragment>
            		<AddNetPromoterScorePointsTrackingComponent
                        addNetPromoterScoreTrackingData={this.addNetPromoterScoreTrackingData}
                        orgId={this.state.orgId}
                    />
                    <NetPromoterScorePointsTrackingTable
                        id='NPSPointsTrackingTable' 
                        key="netPromoterScorePointsTrackingTable" 
                        applications={netPromoterScorePointsTrackingResult}
                        deleteNetPromoterScoreTrackingData = {this.deleteNetPromoterScoreTrackingData}
                    />
            		</React.Fragment>    
            	)
		} else if (netPromoterScorePointsTrackingResult.length === 0){
        return (
        		<React.Fragment>
        		<AddNetPromoterScorePointsTrackingComponent
                    addNetPromoterScoreTrackingData={this.addNetPromoterScoreTrackingData}
                    orgId={this.state.orgId}
                />
                <h5 id="noResults">NetPromoterScore points tracking not available for the search criteria</h5>
                </React.Fragment>    
            )
		}
    }

    refreshPage = (pageNumber, pageItems) => {
        this.setState({
            pageItems:pageItems
        });
	}
}

class NetPromoterScorePointsTrackingTable extends React.Component {
    // useless constructor warning
    // constructor(props) {
    //     super(props);
    // }

    render() {

        const { deleteNetPromoterScoreTrackingData} = this.props;
        var rows = [];
        this.props.applications.forEach(function(app, index) {
            rows.push(
                <Application 
                    key={index} 
                    app={app}
                    deleteNetPromoterScoreTrackingData = {deleteNetPromoterScoreTrackingData}
                />
            );
        });
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                            <h1>NetPromoterScore Points Tracker</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 tableWrapper bg-white table-responsive-lg">
                            <table className="table table-striped">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col">NetPromoterScore Category</th>
                                        <th scope="col">Date Updated</th>
                                        <th scope="col">Created By</th>
                                        <th scope="col">Comments</th>
                                        <th scope="col">Delete</th>
                                    </tr>
                                </thead>
                                <tbody>{rows}</tbody>
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

class Application extends React.Component {
    // useless constructor warning
    // constructor(props) {
    //   super(props);
    // }

    render() {
        const { deleteNetPromoterScoreTrackingData} = this.props;
        var comments = this.props.app.comments;
        if(this.props.app.comments == null || this.props.app.comments === undefined){
            comments = 'None';
        }
      return (
        <tr>
          <td>{this.props.app.category}</td>
          <td>{this.convertDate(this.props.app.dateCreated.epochSecond)}</td>
          <td>{this.props.app.actor.firstName} {this.props.app.actor.lastName}</td>
          <td>{comments}</td>
          <td onClick={() => { deleteNetPromoterScoreTrackingData(this.props.app)}}><i className="fas fa-trash-alt"></i></td>
        </tr>);
    }

  convertDate = (epochSecond) => {
      var date = new Date(0);
      date.setUTCSeconds(epochSecond);
      return date.toLocaleDateString();
  }
}

export default NetPromoterScorePointsTracking;


// WEBPACK FOOTER //
// ./src/firstnet/NetPromoterScore/NetPromoterScorePointsTracking.js